import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogContent,
  Divider,
  FormControl,
  FormControlLabel,
  IconButton,
  Input,
  Menu,
  Paper,
  Radio,
  RadioGroup,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, { Fragment, useRef, useState } from "react";
import { useDashboard } from "./hooks/useDashboard";
import { Controller, useForm } from "react-hook-form";
import { Formater } from "../../hooks/formater";
import { Loader, ModalLoader } from "../../components/Loader";
import CloseIcon from "@mui/icons-material/Cancel";
import CheckIcon from "@mui/icons-material/CheckCircle";
import CircleIcon from "@mui/icons-material/Circle";
import { useDialogControl } from "../../components/openDialog";
import { useMutation } from "react-query";
import { AppDialog } from "../../components/Dialog";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import DeleteIcon from "@mui/icons-material/Delete";
import { alpha } from "@mui/material/styles";
import { PieChart } from "@mui/x-charts";
import { useTheme } from "@emotion/react";
import { toast } from "react-toastify";
import { AppImage } from "../../components/AppImage";
import { Print } from "@mui/icons-material";

const Legend = (props) => (
  <Box
    sx={{
      display: "flex",
      gap: 0.5,
      alignItems: "center",
    }}
  >
    <CircleIcon fontSize="5" color={props.color}></CircleIcon>
    <Typography variant="caption">{props.children}</Typography>
  </Box>
);

export const DashboardModal = (props) => {
  const dashboard = useDashboard();
  const separateDialog = useDialogControl();

  const form = useForm({
    defaultValues: {
      quantity: 0,
    },
  });

  const theme = useTheme();

  const [printDropdownAnchor, setPrintDropdownAnchor] = useState(null);
  const handlePrintOrderForm = ({
    showPrices,
    showDiscounts,
    internal,
    showTerm,
  }) => {
    setPrintDropdownAnchor(null);
    return toast.promise(
      dashboard.printOrder.mutateAsync({
        showPrices,
        showDiscounts,
        internal: JSON.parse(internal),
        showTerm,
        orderId: dashboard.orderData.data.id,
      }),
      {
        error: "Erro ao separar todos os itens",
      }
    );
  };

  const printOrderForm = useForm({
    defaultValues: {
      showPrices: true,
      showDiscounts: true,
      internal: false,
    },
  });

  const openPrintDropdown = (event) => {
    setPrintDropdownAnchor(event.currentTarget);
  };

  const countActiveItems = (items) => {
    return items.filter((item) => !item.deleted).length;
  };

  const orderIframe = useRef(null);

  return (
    <>
      <Dialog
        open={separateDialog.isOpened}
        onTransitionEnter={() => {
          form.setFocus("quantity");
        }}
        onClose={() => {
          separateDialog.reject();
        }}
      >
        <DialogContent>
          <form
            onSubmit={form.handleSubmit((data) =>
              separateDialog.select({ quantity: data.quantity })
            )}
          >
            <Box
              sx={{
                display: "flex",
                gap: 2,
              }}
            >
              <Input
                type="tel" /* keeps full control over formatting */
                inputMode="numeric" /* iOS+Android show number keypad   */
                pattern="[0-9]*" /* Android <10 still needs this     */
                {...form.register("quantity", {
                  min: 0,
                  valueAsNumber: true,
                  required: true,
                })}
              ></Input>
              <Button type="submit">Separar</Button>
            </Box>
          </form>
        </DialogContent>
      </Dialog>

      <AppDialog
        open={props.open}
        onClose={props.onClose}
        headerContent={
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              marginRight: 10,
              width: "100%",
            }}
          >
            <Button
              onClick={() => {
                toast.promise(
                  dashboard.separateAllItems.mutateAsync(
                    dashboard.orderData.data.id
                  ),
                  {
                    error: "Erro ao separar todos os itens",
                  }
                );
              }}
              disabled={
                dashboard.separateAllItems.isLoading ||
                dashboard.isCompletelySeparated
              }
              variant="contained"
              color="secondary"
              startIcon={
                <Loader
                  loading={dashboard.separateAllItems.isLoading}
                  size={20}
                >
                  <CheckIcon size={20} />
                </Loader>
              }
            >
              {dashboard.isCompletelySeparated ? "Separado" : "Separar tudo"}
            </Button>
          </Box>
        }
        headerSpace={true}
        PaperProps={{
          sx: {
            maxWidth: "100vw",
            margin: 1,
          },
        }}
      >
        <DialogContent>
          <ModalLoader query={dashboard.orderData}>
            <>
              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                  flexWrap: "wrap",
                  justifyContent: "space-between",
                  lineHeight: 1,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    lineHeight: 1,
                  }}
                >
                  <Menu
                    anchorEl={printDropdownAnchor}
                    open={Boolean(printDropdownAnchor)}
                    label="Select Option"
                    onClose={() => setPrintDropdownAnchor(null)}
                  >
                    <Box
                      component="form"
                      onSubmit={printOrderForm.handleSubmit(
                        handlePrintOrderForm
                      )}
                      sx={{
                        p: 2,
                        display: "flex",
                        flexDirection: "column",
                        gap: 1,
                      }}
                    >
                      <FormControl>
                        <Controller
                          name="internal"
                          control={printOrderForm.control}
                          render={({ field }) => (
                            <RadioGroup
                              sx={{
                                display: "flex",
                              }}
                              {...field}
                            >
                              <FormControlLabel
                                value={true}
                                control={<Radio />}
                                label="Interno"
                              />
                              <FormControlLabel
                                value={false}
                                control={<Radio />}
                                label="Cliente"
                              />
                            </RadioGroup>
                          )}
                        />
                      </FormControl>
                      <FormControlLabel
                        control={
                          <Controller
                            name="showPrices"
                            control={printOrderForm.control}
                            disabled={
                              printOrderForm.watch("internal") === "true"
                            }
                            render={({ field }) => {
                              return (
                                <Checkbox checked={field.value} {...field} />
                              );
                            }}
                          />
                        }
                        label="Mostrar preços"
                      />
                      <FormControlLabel
                        control={
                          <Controller
                            name="showDiscounts"
                            disabled={
                              printOrderForm.watch("internal") === "true"
                            }
                            control={printOrderForm.control}
                            render={({ field }) => {
                              return (
                                <Checkbox checked={field.value} {...field} />
                              );
                            }}
                          />
                        }
                        label="Mostrar descontos"
                      />
                      <FormControlLabel
                        control={
                          <Controller
                            name="showTerm"
                            control={printOrderForm.control}
                            render={({ field }) => {
                              return (
                                <Checkbox checked={field.value} {...field} />
                              );
                            }}
                          />
                        }
                        label="Mostrar termo"
                      />
                      <Button type="submit" variant="contained" size="small">
                        Visualizar
                      </Button>
                    </Box>
                  </Menu>
                  <Button
                    onClick={openPrintDropdown}
                    disabled={dashboard.printOrder.isLoading}
                    sx={{
                      width: "fit-content",
                      marginBottom: 1,
                    }}
                    startIcon={
                      <Print
                        sx={{
                          maxWidth: 40,
                          maxHeight: 40,
                        }}
                      />
                    }
                  >
                    <Loader
                      loading={dashboard.printOrder.isLoading}
                      size={30}
                      sx={{
                        width: 40,
                      }}
                    >
                      Visualizar
                    </Loader>
                  </Button>
                  <Typography variant="caption" style={{ lineHeight: 1.3 }}>
                    <strong>Pedido:</strong> {dashboard.orderData.data?.id}
                  </Typography>
                  <Typography variant="caption" style={{ lineHeight: 1.3 }}>
                    <strong>Saída:</strong>{" "}
                    {dashboard.orderData.data?.exit.format("DD/MM/YYYY")}
                  </Typography>
                  <Typography variant="caption" style={{ lineHeight: 1.3 }}>
                    <strong>Retorno:</strong>{" "}
                    {dashboard.orderData.data?.return.format("DD/MM/YYYY")}
                  </Typography>
                  <Typography variant="caption" style={{ lineHeight: 1.3 }}>
                    <strong>Atendente:</strong>{" "}
                    {dashboard.orderData.data?.attendant}
                  </Typography>
                  <Typography variant="caption" style={{ lineHeight: 1.3 }}>
                    <strong>Cliente:</strong>{" "}
                    {dashboard.orderData.data?.partner}
                  </Typography>
                  <Typography variant="caption" style={{ lineHeight: 1.3 }}>
                    <strong>Entrega:</strong>{" "}
                    {dashboard.orderData.data?.deliveryTime}
                  </Typography>
                  <Typography variant="caption" style={{ lineHeight: 1.3 }}>
                    <strong>Total:</strong>{" "}
                    {(dashboard.orderData.data?.itemsList?.length || 0) -
                      (dashboard.orderData.data?.deletedItemList.length ||
                        0)}{" "}
                    produtos unicos
                  </Typography>
                  <Typography variant="caption" style={{ lineHeight: 1.3 }}>
                    <strong>Deletados:</strong>{" "}
                    {dashboard.orderData.data?.deletedItemList.length}
                  </Typography>
                  <Typography variant="caption" style={{ lineHeight: 1.3 }}>
                    <strong>Separado:</strong>{" "}
                    {Formater.percent.format(
                      dashboard.orderData.data?.separatedProportion
                    )}
                  </Typography>
                  <Typography
                    variant="caption"
                    style={{ lineHeight: 1.3, maxWidth: 320 }}
                  >
                    {dashboard.orderData.data?.notes?.slice(0, 80)}
                    {dashboard.orderData.data?.notes?.length > 80 && "..."}
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{
                      color:
                        dashboard.orderData.data?.warningCount > 0
                          ? (theme) => theme.palette.danger.light
                          : undefined,
                    }}
                  >
                    <strong>Problemas:</strong>{" "}
                    {dashboard.orderData.data?.warningCount || 0}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    overflow: "hidden",
                    maxWidth: 200,
                    maxHeight: 200,
                  }}
                >
                  <Box
                    sx={{
                      maxWidth: 200,
                      maxHeight: 200,
                      overflow: "visible",
                      transform: "translateY(-50px)",
                    }}
                  >
                    <PieChart
                      slotProps={{
                        legend: { hidden: true },
                      }}
                      series={[
                        {
                          valueFormatter: ({ data }) => {
                            return Formater.percent.format(data);
                          },
                          data: [
                            {
                              id: 0,
                              value:
                                dashboard.orderData.data
                                  ?.notSeparatedProportion,
                              label: "Não separado",
                              color: theme.palette.warning.light,
                            },
                            {
                              id: 1,
                              value:
                                dashboard.orderData.data?.separatedProportion,
                              label: "Separado",
                              color: theme.palette.success.main,
                            },
                            {
                              id: 2,
                              value:
                                dashboard.orderData.data?.problemsProportion,
                              label: "Problemas",
                              color: theme.palette.error.main,
                            },
                          ],
                        },
                      ]}
                      width={250}
                      height={250}
                    />
                  </Box>
                </Box>
              </Box>
            </>

            <Box
              sx={{
                display: "flex",
                gap: 2,
                flexWrap: "wrap",
                alignItems: "center",
                justifyContent: "flex-end",
                marginBottom: "1rem",
                marginTop: "1rem",
              }}
            >
              <Legend color="warning">Não separado</Legend>
              <Legend color="success">Separado</Legend>
              <Legend color="error">Problemas</Legend>
            </Box>
            <Divider></Divider>
            <Box
              sx={{
                minHeight: "min(700px, calc(100vh - 2rem))",
                minWidth: "min(100vw, calc(600px - 4rem))",
              }}
            >
              <AppDialog
                open={!!dashboard.selectedOrderHtml}
                onClose={() => {
                  dashboard.unselectOrderHtml();
                }}
                headerContent={
                  <>
                    <Button
                      onClick={() => {
                        dashboard.printOrder.mutateAsync({
                          ...dashboard.selectedOrderHtml?.form,
                          pdf: true,
                        });
                      }}
                      startIcon={
                        <Print
                          sx={{
                            maxWidth: 40,
                            maxHeight: 40,
                          }}
                        />
                      }
                    >
                      Imprimir Pedido
                    </Button>
                  </>
                }
                sx={{
                  "& .MuiDialog-paper": {
                    width: "100%",
                    maxWidth: "calc(100vw - 2rem)",
                    maxHeight: "calc(100vh - 2rem)",
                    margin: 0,
                    padding: 0,
                  },
                  "& .MuiDialogContent-root": {
                    padding: 0,
                  },
                  "& .MuiDialogActions-root": {
                    padding: 0,
                  },
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Box
                    component={"iframe"}
                    sx={{
                      width: "210mm", // A4 width
                      overflow: "scroll",
                      height: "calc(100vh - 2rem)",
                      border: "none",
                    }}
                    ref={orderIframe}
                    srcDoc={dashboard.selectedOrderHtml?.html}
                  ></Box>
                </Box>
              </AppDialog>

              {Object.entries(dashboard.orderData.data?.items || {}).map(
                ([id, data]) =>
                  data.data?.length &&
                  countActiveItems(data.data) > 0 && (
                    <Fragment key={data.label}>
                      <Box
                        sx={{
                          display: "flex",
                          gap: 1,
                          alignItems: "center",
                          marginBottom: 2,
                          marginTop: 2,
                        }}
                      >
                        <Typography variant="h5">{data.label}</Typography>
                        <SeparationGroupButton
                          orderData={dashboard.orderData.data}
                          groupFamilyId={Number(id)}
                          orderId={dashboard.orderData.data.id}
                        />
                      </Box>
                      <TableContainer component={Paper}>
                        <Table stickyHeader aria-label="simple table">
                          <TableHead>
                            <TableRow>
                              <TableCell align="center">Produto</TableCell>
                              <TableCell align="center">Localização</TableCell>
                              <TableCell align="center">Qtde</TableCell>
                              <TableCell align="center">
                                Qtde Separada
                              </TableCell>
                              <TableCell align="center">Separar</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {(data.data || []).map((row) => (
                              <Fragment key={row.id}>
                                {(!row.deleted ||
                                  row.separatedQuantity != 0) && (
                                  <Row
                                    row={row}
                                    separateDialog={separateDialog}
                                  ></Row>
                                )}
                              </Fragment>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Fragment>
                  )
              )}
            </Box>
          </ModalLoader>
        </DialogContent>
      </AppDialog>
    </>
  );
};
const placeholderImage =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAIAAACRXR/mAAAAFklEQVR4nO3BMQEAAADCoPdPbQ43oAAAAAAAAAAAANwGAn0AAc8GXNMAAAAASUVORK5CYII=";

const Row = (props) => {
  const { row, separateDialog } = props;
  const dashboard = useDashboard();

  const separate = useMutation({
    mutationFn: async () => {
      let quantity;
      try {
        let response = await separateDialog.open();

        if (response.quantity > row.quantity) {
          return toast.error("Não pode separar mais que a quantidade total");
        }

        quantity = response.quantity;
      } catch (error) {
        return;
      }

      await dashboard.separateItem.mutateAsync({
        row,
        quantity,
      });
    },
  });

  const checkItem = useMutation({
    mutationFn: () => dashboard.checkItem.mutateAsync(row),
  });

  const clear = useMutation({
    mutationFn: () => {
      return dashboard.separateItem.mutateAsync({
        row,
        quantity: null,
      });
    },
  });

  const problems = dashboard.getItemProblem(row);

  const buttonRef = useRef();
  const [selectedImage, setSelectedImage] = React.useState(null);

  const selectImage = (image) => {
    setSelectedImage(image);
  };

  const getProblemColor = (problem, theme) => {
    return alpha(theme.palette.danger.main, 0.2);
  };

  const getSepartionText = () => {
    let text = `Separado por ${row.employeeFromLastAlteration}`;
    if (row.timeFromLastAlteration) {
      text += ` às ${row.timeFromLastAlteration.format("DD/MM/YYYY HH:mm")}`;
    }

    return (
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Typography
          sx={{
            fontSize: 8,
            maxWidth: 160,
            textAlign: "center",
          }}
        >
          {text}
        </Typography>
      </Box>
    );
  };


  return (
    <>
      <AppDialog open={!!selectedImage} onClose={() => setSelectedImage(null)}>
        <AppImage src={selectedImage} />
      </AppDialog>

      <TableRow
        sx={{
          backgroundColor: problems
            ? (theme) => getProblemColor(problems, theme)
            : undefined,
          cursor: "pointer",
        }}
        onClick={() => {
          buttonRef.current?.click();
        }}
      >
        <TableCell
          align="center"
          sx={{
            padding: 1,
            fontSize: 18,
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            gap: 2,
          }}
        >
          <Box
            sx={{
              height: 50,
              width: 50,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <AppImage
              src={row.imageUrl || placeholderImage}
              sx={{
                maxHeight: 50,
                maxWidth: 50,
              }}
              onClick={(e) => {
                selectImage(row.imageUrl);
                e.stopPropagation();
              }}
            />
          </Box>
          {row.productName}
        </TableCell>
        <TableCell align="center" style={{ padding: 1 }}>
          <Typography variant="caption">{row.location}</Typography>
          {!!row.partnerId && !!row.location && <br />}
          {!!row.partnerId && (
            <Typography
              variant="caption"
              sx={{
                fontWeight: "bold",
              }}
            >
              ({row.partnerName})
            </Typography>
          )}
        </TableCell>
        <TableCell align="center" style={{ padding: 1, fontSize: 24 }}>
          {Formater.number.format(row.quantity)}
        </TableCell>

        <TableCell align="center" style={{ padding: 1, fontSize: 24 }}>
          {row.separatedQuantity != null
            ? Formater.number.format(row.separatedQuantity)
            : ""}
        </TableCell>

        <TableCell align="center" style={{ padding: 1 }}>
          <Loader
            loading={
              checkItem.isLoading || separate.isLoading || clear.isLoading
            }
          >
            {!problems &&
            (!row.separatedQuantity || row.separatedQuantity == 0) ? (
              <Box>
                <IconButton
                  color="error"
                  onClick={checkItem.mutate}
                  aria-label="separar"
                  sx={{ padding: 0 }}
                  ref={buttonRef}
                >
                  <CloseIcon
                    sx={{
                      fontSize: 40,
                    }}
                  />
                </IconButton>
                {row.employeeFromLastAlteration && getSepartionText()}
              </Box>
            ) : !problems ? (
              <Box>
                <IconButton
                  onClick={separate.mutate}
                  color="success"
                  aria-label="separar"
                  size="large"
                  sx={{ padding: 0 }}
                  ref={buttonRef}
                >
                  <CheckIcon
                    sx={{
                      fontSize: 40,
                    }}
                  />
                </IconButton>
                {row.employeeFromLastAlteration && getSepartionText()}
              </Box>
            ) : (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <IconButton
                  onClick={clear.mutate}
                  color="warning"
                  aria-label="separar"
                  size="large"
                  sx={{ padding: 0 }}
                  ref={buttonRef}
                >
                  {problems === "deletedAndSeparated" ? (
                    <DeleteIcon
                      sx={{
                        fontSize: 40,
                        color: (theme) => theme.palette.danger.main,
                      }}
                    />
                  ) : (
                    <WarningAmberIcon
                      sx={{
                        fontSize: 40,
                      }}
                    />
                  )}
                </IconButton>
                {row.employeeFromLastAlteration && getSepartionText()}
              </Box>
            )}
          </Loader>
        </TableCell>
      </TableRow>
    </>
  );
};

/**
 *
 * @param {{
 *  groupFamilyId: number;
 *  orderId: number;
 *  orderData: import("../../hooks/api/dashboard").OrderData;
 * }} props
 */
const SeparationGroupButton = (props) => {
  const dashboard = useDashboard();
  const separateItemsByGroupId = dashboard.makeSeparateItemsByGroupIdFn(props);

  const isCompletelySeparated = dashboard.isFamilyGroupIdCompletelySeparated(
    props.orderData,
    props.groupFamilyId
  );

  return (
    <Box sx={{}}>
      <Button
        onClick={() => {
          toast.promise(separateItemsByGroupId.mutateAsync(), {
            error: "Erro ao separar todos os itens do grupo",
          });
        }}
        disabled={separateItemsByGroupId.isLoading || isCompletelySeparated}
        color="secondary"
        startIcon={
          <Loader loading={separateItemsByGroupId.isLoading} size={20}>
            <CheckIcon size={20} />
          </Loader>
        }
      >
        {isCompletelySeparated ? "Separado" : "Separar tudo"}
      </Button>
    </Box>
  );
};
